import { ChevronLeft, ChevronRight } from '@corecomponents/icons'

export interface ArrowProps {
  className?: string
  prevArrowClass?: string
  nextArrowClass?: string
  currentSlide?: number
  'data-role'?: string
  onClick?: () => void
  slideCount?: number
  style?: {
    [key: string]: any
  }
  infinite: boolean
}

export const NextArrow = (props: ArrowProps) => {
  return (
    <div
      className={`${
        props.onClick === null && !props.infinite ? 'hidden' : 'flex'
      } absolute top-1/2 -right-12 translate-x-0 -translate-y-1/2 w-10 h-10 shadow-lg bg-white rounded-full items-center justify-center cursor-pointer z-10`}
      onClick={props.onClick}
      data-role="none"
    >
      <ChevronRight />
    </div>
  )
}

export const PrevArrow = (props: ArrowProps) => {
  return (
    <div
      className={`${
        props.onClick === null && !props.infinite ? 'hidden' : 'flex'
      } absolute top-1/2 -left-12 translate-x-0 -translate-y-1/2 w-10 h-10 shadow-lg bg-white rounded-full flex items-center justify-center cursor-pointer z-10`}
      onClick={props.onClick}
      data-role="none"
    >
      <ChevronLeft />
    </div>
  )
}
